import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@material-ui/core";
import {
  MapContainer,
  Marker,
  Polyline,
  TileLayer,
  Tooltip
} from "react-leaflet";
import { orangeIcon, parseCoordinates } from "../../../../util/leaflet-utils";

const MapModal = props => {
  let dropLatLong = [0, 0];
  let siteLatLong = [0, 0];

  if (props.mapModalOpen) {
    const { startLocation, bottomLocation, endLocation } = props.mapModalForm;

    const targetLocation = [startLocation, bottomLocation, endLocation].find(
      x => x !== null
    );

    const { lat, long } = parseCoordinates(targetLocation);
    dropLatLong = [lat, long];

    const siteInfo = props.siteData[props.mapModalForm.siteId];
    siteLatLong = [siteInfo.latitude, siteInfo.longitude];
  }

  return (
    <Dialog open={props.mapModalOpen}>
      <DialogTitle>Cast Location</DialogTitle>
      <DialogContent>
        <Typography>
          <span>{`Target site: ${props.mapModalForm.siteId}`}</span>
          <span
            style={{ float: "right" }}
          >{`Distance between drop and site: ${props.mapModalForm.distanceFromSampleSite} m`}</span>
        </Typography>
        <div>
          <MapContainer
            style={{ width: "550px", height: "400px" }}
            center={dropLatLong}
            zoom={12}
            scrollWheelZoom
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={dropLatLong} icon={orangeIcon}>
              <Tooltip>Drop Location</Tooltip>
            </Marker>
            <Polyline
              pathOptions={{ color: "red" }}
              positions={[dropLatLong, siteLatLong]}
            />

            {props.mapSiteData !== undefined &&
              props.mapSiteData.map(entry => {
                const siteInfo = props.siteData[entry.name];
                if (
                  siteInfo !== undefined &&
                  siteInfo.latitude !== undefined &&
                  siteInfo.longitude !== undefined
                ) {
                  return (
                    <Marker
                      key={entry.name}
                      position={[siteInfo.latitude, siteInfo.longitude]}
                    >
                      <Tooltip
                        permanent={entry.name === props.mapModalForm.siteId}
                      >
                        Site: {entry.name}
                      </Tooltip>
                    </Marker>
                  );
                }
                return <></>;
              })}
          </MapContainer>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={props.onMapModalClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const formShape = PropTypes.shape({
  dropStartTime: PropTypes.string,
  dropBottomTime: PropTypes.string,
  startLocation: PropTypes.string,
  bottomLocation: PropTypes.string,
  endLocation: PropTypes.string,
  survey: PropTypes.string,
  siteId: PropTypes.string,
  distanceFromSampleSite: PropTypes.number,
  targetDepthM: PropTypes.number,
  drop: PropTypes.number,
  miscast: PropTypes.bool,
  fieldStaff: PropTypes.string,
  qualityLog: PropTypes.string,
  pk: PropTypes.number
});

const castShape = PropTypes.shape({
  ctdFilePk: PropTypes.number,
  ctdCastPk: PropTypes.number,
  startDt: PropTypes.string,
  bottomDt: PropTypes.string,
  matchingForm: formShape,
  possibleForms: PropTypes.arrayOf(formShape)
});

const mapSiteDataShape = PropTypes.shape({
  name: PropTypes.string
});

MapModal.propTypes = {
  onMapModalClose: PropTypes.func.isRequired,
  mapModalOpen: PropTypes.bool.isRequired,
  mapModalCast: castShape.isRequired,
  mapModalForm: formShape.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  siteData: PropTypes.object.isRequired,
  mapSiteData: PropTypes.arrayOf(mapSiteDataShape).isRequired
};

export default MapModal;
